module.exports = __webpack_public_path__ + "static/media/14_crear_menu_plantilla_complejo_galeria_foto.27933ccd.jpg";